module.exports = __webpack_public_path__ + "img/shield-chaos.88b603a5.jpg";